/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the home page

    $(document).on('scroll', function() {
      if($(document).scrollTop()>150) {
        $('.c_line').addClass('active');
      } else {
        // $('.banner').removeClass('smaller');
      }
    });

    if ($(window).width() > 1024) {
      skrollr.init({
        smoothScrolling: true,
        forceHeight: false,
      });
    }

    $('a[rel="relativeanchor"]').click(function(){
  	    $('html, body').animate({
  	        scrollTop: $( $.attr(this, 'href') ).offset().top + 100
  	    }, 500);
  	    return false;
  	});


    $('#initVid').click(function(){
  	   $('#video_wrap').html('<iframe src="https://www.youtube.com/embed/pFptt7Cargc?rel=0&amp;autoplay=1&mute=1" frameborder="0" allowfullscreen></iframe>');
  	});

    $('.close_vid').click(function(){
  	   $('#video_wrap').html('');
  	});

    $('.email[aria-invalid="true"]').addClass('FUCK');



  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js